/** Harbor's five project roles, under Harbor's own names, weakest first.
 *
 * Each role holds every permission of the roles before it (Harbor's
 * `rolePower`), so the order is the rank. Harbor's role ids are not in rank
 * order (1 projectAdmin, 2 developer, 3 guest, 4 maintainer, 5 limitedGuest),
 * so compare roles with {@link harborRoleRank}, never by id.
 */
export const HARBOR_ROLES = [
  "limitedGuest",
  "guest",
  "developer",
  "maintainer",
  "projectAdmin",
] as const;

export type HarborRole = (typeof HARBOR_ROLES)[number];

/** A role's place in {@link HARBOR_ROLES}: a higher rank holds every
 * permission of a lower one. */
export const harborRoleRank = (role: HarborRole): number =>
  HARBOR_ROLES.indexOf(role);

/** What a request's `priorRole` records: the user's direct role on the
 * project before the grant, or `none` when they had none. A recorded `none`
 * tells "had no role" apart from a request whose prior role was never
 * recorded. */
export const HARBOR_PRIOR_ROLES = ["none", ...HARBOR_ROLES] as const;

/** What a system administrator request's `wasSystemAdmin` records, as a
 * string: generated data holds strings. */
export const HARBOR_WAS_SYSTEM_ADMIN = ["false", "true"] as const;
